import Point from '../Utility/Point';
import Component from './Component';
import ObservablePoint from '../Utility/ObservablePoint';

export enum TransformEvent {
    POSITION_CHANGED = "positionChanged",
    ROTATION_CHANGED = 'rotationChanged',
    SCALE_CHANGED = 'scaleChanged',
}
export default class TransformComponent extends Component {
    /**
     * Invisible offset point used for relative positioning.
     */
    public offset: Point = new Point();

    private _position: ObservablePoint = new ObservablePoint(() => {
        this.container.x = this._position.x + this.offset.x;
        this.container.y = this._position.y + this.offset.y;
        this.gameObject.emit(TransformEvent.POSITION_CHANGED, this.position)
    }, this);

    public get rotation(): number {
        return this.container.rotation;
    }

    public set rotation(rotation: number) {
        this.container.rotation = rotation;
        this.gameObject.emit(TransformEvent.ROTATION_CHANGED, rotation);
    }

    public get width(): number {
        return this.container.width;
    }

    public set width(width: number) {
        this.container.width = width;
    }

    public get height(): number {
        return this.container.height;
    }

    public set height(height: number) {
        this.container.height = height;
    }

    public get x(): number {
        return this._position.x;
    }

    public set x(x: number) {
        this._position.x = x;
    }

    public get y(): number {
        return this._position.y;
    }

    public set y(y: number) {
        this._position.y = y;
    }

    public get position(): Point | ObservablePoint {
        return this._position as Point | ObservablePoint;
    }

    public set position(point: Point | ObservablePoint) {
        this._position.set(point.x, point.y);
    }

    public get scale(): Point | ObservablePoint {
        return this.container.scale as Point | ObservablePoint;
    }

    public set scale(point: Point | ObservablePoint) {
        this.container.scale.set(point.x, point.y);
        this.gameObject.emit(TransformEvent.SCALE_CHANGED, point);
    }

    public get skew(): ObservablePoint {
        return this.container.skew as ObservablePoint;
    }

    public set skew(point: ObservablePoint) {
        this.container.skew.set(point.x, point.y);
    }

    public get pivot(): Point | ObservablePoint {
        return this.container.pivot as Point | ObservablePoint;
    }

    public set pivot(point: Point | ObservablePoint) {
        this.container.pivot.set(point.x, point.y);
    }

    public get globalPosition(): Point | ObservablePoint {
        return this.container.toGlobal(this.position) as Point | ObservablePoint;
    }

    public toLocal(point: Point | ObservablePoint, from?: TransformComponent, out?: Point | ObservablePoint): Point {
        return this.container.toLocal(point, from?.container, out);
    }

    public toGlobal(point: Point | ObservablePoint, out?: Point | ObservablePoint): Point {
        return this.container.toGlobal(point, out);
    }
}
